import { AbstractEntityMapper } from '@pf/shared-services';
import {
    RequisitionLineCreate,
    RequisitionLineDto,
    RequisitionLineRead,
    RequisitionLineSearchParams,
} from '../../entities/requisition-line.dto';
import { Injectable } from '@angular/core';
import { PlatformWmsMapper } from '../platform-wms.mapper';
import { RequisitionLineMetadataMap } from './requisition-line.mapping-profile';

@Injectable()
export class RequisitionLineMapper extends AbstractEntityMapper<
    RequisitionLineRead,
    RequisitionLineCreate,
    RequisitionLineDto,
    RequisitionLineSearchParams
> {
    constructor() {
        super(
            RequisitionLineDto,
            PlatformWmsMapper,
            RequisitionLineMetadataMap.symbols
        );
    }
}
